import { useTracking } from '../../hooks';

type ChatAnalyticsEvents = {
  'Chat Ended': {
    questions_asked: number;
  };
  'Question Asked': {
    question: string;
    type: 'text' | 'voice' | 'recommended';
  };
  'Answer Received': {
    question: string;
    answer: string;
  };
  'Chat Link Clicked': {
    link_url: string;
    source: 'empty-response' | 'chat-header' | 'first-step';
  };
};

const useTrackingChat = () => {
  const { trackEvent, timeEvent } = useTracking();

  const track = (
    event: keyof ChatAnalyticsEvents,
    properties: ChatAnalyticsEvents[keyof ChatAnalyticsEvents]
  ) => {
    trackEvent(event, properties);
  };

  const time = (event: keyof ChatAnalyticsEvents) => {
    timeEvent(event);
  };

  return { track, time };
};

export default useTrackingChat;
